export class Site {
    id: string;
    title: string;
    publisherId: string;
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/models/site.ts